export class FormUtils {
    static parseErrorMsgs = (errors: any): string[] | null => {
        if (!errors) return null

        if (typeof errors === 'string') {
            return [errors]
        }

        const msgs: string[] = []

        const walk = (node: any, path: string[] = []) => {
            if (!node) return

            if (Array.isArray(node)) {
                if (node.every((v) => typeof v === 'string')) {
                    msgs.push(`${path.join('.')}: ${node.join(', ')}`)
                } else {
                    node.forEach((item, i) => walk(item, [...path, String(i)]))
                }
                return
            }

            if (typeof node === 'object') {
                Object.keys(node).forEach((key) => {
                    walk(node[key], [...path, key])
                })
                return
            }

            msgs.push(`${path.join('.')}: ${String(node)}`)
        }

        walk(errors)
        return msgs
    }
}
